<template>
  <h1>We're sorry</h1>
  <h3>We can't fine the page you're looking for!</h3>
</template>

<script>
export default {

}
</script>

<style>

</style>